export const getFormattedPrice = (price) => {
  return price.toLocaleString('ru-RU');
}